import { Box, makeStyles, Typography } from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";
import {
	handleImprimirEtiqueta,
	handleImprimirNota,
	handleUpdateEventImprimirNotaFiscal,
} from "../../../../state/order/actions";
import { downloadPdf } from "../../helpers/downloadPdf";
import WarningIcon from "../../icons/WarningIcon";
import { EtiquetaIndisponivelModal } from "../EtiquetaIndisponivelModal";
import Step from "./Step";

const useStyles = makeStyles(() => ({
	container: {
		padding: "1.5rem 1rem",
		gap: "1.5rem",
		flexDirection: "column",
		borderBottom: "1px solid #DCDCDC",
		marginBottom: "1.5rem",
	},
	titleContainer: {
		alignItems: "center",
		gap: "0.5rem",
		color: "rgba(26, 26, 26, 0.87)",
		marginBottom: "0.5rem",
	},
	title: {
		lineHeight: "1",
	},
	caption: {
		fontSize: "14px",
	},
}));

const MandatorySteps = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [modalObject, setModalObject] = useState({isModalOpen: false, message: ""});

	const {
		order: { events, numero, notaFiscal },
	} = useSelector((state) => state.orders);

	const notaFiscalEvent = events.find(
		(event) =>
			event.eventName === "PRONTO_PARA_SAIR" && event.tipo === "NOTA_FISCAL",
	);
	const imprimirNotaEvent = events.find(
		(event) =>
			event.eventName === "PRONTO_PARA_SAIR" &&
			event.tipo === "IMPRIMIR_NOTA_FISCAL",
	);
	const imprimirEtiquetaEvent = events.find(
		(event) =>
			event.eventName === "PRONTO_PARA_SAIR" &&
			event.tipo === "IMPRIMIR_ETIQUETA",
	);

	const handleImprimirNotaClick = async () => {
		if (loading) return;
		setLoading(true);

		try {
			if (imprimirNotaEvent?.status !== "DONE") {
				const resUpdate = await dispatch(
					handleUpdateEventImprimirNotaFiscal(numero, notaFiscal?.chave),
				);
				if (!resUpdate || resUpdate.status !== 200) {
					return;
				}
			}

			const res = await dispatch(handleImprimirNota(numero));

			if (res && res.status === 200) {
				downloadPdf(res.data, `nota-${numero}`);
			}
		} finally {
			setLoading(false);
		}
	};

	const handleImprimirEtiquetaClick = async () => {
		if (loading) return;
		setLoading(true);

		try {
			const res = await dispatch(handleImprimirEtiqueta(numero));
			if (res && res.status === "SHOULD_OPEN_MODAL") {
				setModalObject({ isModalOpen: true, message: res.message });
				return;
			}
			if (res && res.status === 200) {
				downloadPdf(res.data, `etiqueta-${numero}`);
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<Box display={"flex"} className={classes.container}>
			<Box>
				<Box display={"flex"} className={classes.titleContainer}>
					<WarningIcon />
					<Typography variant="h6" className={classes.title}>
						Para enviar o pedido, siga as etapas obrigatórias
					</Typography>
				</Box>
				<Typography variant="caption" className={classes.caption}>
					Pedidos com entrega estadual exigem a impressão da nota fiscal e da
					etiqueta de transporte. A etiqueta estará disponível após a impressão
					da nota.
				</Typography>
			</Box>
			<Step
				isPreviousEventPending={notaFiscalEvent.status === "PENDING"}
				{...imprimirNotaEvent}
				onAction={handleImprimirNotaClick}
				disabled={loading}
			/>
			<Step
				isPreviousEventPending={imprimirNotaEvent.status === "PENDING"}
				{...imprimirEtiquetaEvent}
				onAction={handleImprimirEtiquetaClick}
				disabled={loading}
			/>
			<EtiquetaIndisponivelModal
				open={modalObject.isModalOpen}
				handleClose={() => setModalObject({ isModalOpen: false, message: "" })}
				message={modalObject.message}
			/>
		</Box>
	);
};

export default compose(withRouter)(MandatorySteps);
